/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOneToolTeamDto
 */
export interface GetOneToolTeamDto {
    /**
     * 
     * @type {string}
     * @memberof GetOneToolTeamDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetOneToolTeamDto
     */
    oneToolId: number;
    /**
     * 
     * @type {string}
     * @memberof GetOneToolTeamDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOneToolTeamDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetOneToolTeamDto interface.
 */
export function instanceOfGetOneToolTeamDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "oneToolId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetOneToolTeamDtoFromJSON(json: any): GetOneToolTeamDto {
    return GetOneToolTeamDtoFromJSONTyped(json, false);
}

export function GetOneToolTeamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOneToolTeamDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'oneToolId': json['oneToolId'],
        'name': json['name'],
        'active': json['active'],
    };
}

export function GetOneToolTeamDtoToJSON(value?: GetOneToolTeamDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'oneToolId': value.oneToolId,
        'name': value.name,
        'active': value.active,
    };
}

